

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate to navigate to the login page
import { ToastContainer, toast } from 'react-toastify'; // Import ToastContainer and toast for notifications
import 'react-toastify/dist/ReactToastify.css'; // Import CSS for toast notifications
import { Visibility, VisibilityOff } from '@mui/icons-material'; // Import visibility icons

const ChangePasswordManage = () => {
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState(''); // Only store the new password
  const [loading, setLoading] = useState(false); // Loading state for API request
  const [showPassword, setShowPassword] = useState(false); // State to control password visibility
  const navigate = useNavigate(); // useNavigate hook to navigate after success

  const handleEmailChange = (e) => setEmail(e.target.value);
  const handleNewPasswordChange = (e) => setNewPassword(e.target.value);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword); // Toggle the showPassword state
  };

  const handleSubmit = async () => {
    if (!email || !newPassword) {
      toast.error('Email and New Password are required');
      return;
    }

    setLoading(true); // Start loading state

    try {
      // Send the password change request using PUT method
      const response = await fetch('https://server-side-influencer.onrender.com/manager/change-password', {
        method: 'PUT', 
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, newPassword }), // Send email and newPassword to backend
      });

      const data = await response.json();

      if (response.status === 200) {
        toast.success('Password changed successfully');
        // Navigate to the Manager login page after success
        navigate('/ManagerLogin');
      } else {
        toast.error(data.message || 'Failed to change password');
      }
    } catch (err) {
      toast.error('Error: Password change failed');
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  return (
    <div className="relative flex flex-col justify-center items-center min-h-screen p-6 bg-white">
      
      {/* Title at the very top of the screen */}
      <h3 className="mt-10 absolute top-0 left-1/2 transform -translate-x-1/2 text-3xl font-semibold mb-6 text-black">
      Please Change Your Password
      </h3>

      <div className="flex flex-col justify-center items-center w-full max-w-md mt-0">
        
        {/* Email input field */}
        <form className="max-w-sm w-full mb-4">
          <label htmlFor="email-input" className="block mb-2 text-sm font-medium text-gray-900">
            Email:
          </label>
          <div className="relative">
            <input
              type="email"
              id="email-input"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-lg rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-3 mb-4"
              value={email}
              onChange={handleEmailChange}
              placeholder="Enter your email"
              required
            />
          </div>
        </form>

        {/* New Password input field with show/hide toggle */}
        <form className="max-w-sm w-full">
          <label htmlFor="new-password-input" className="block mb-2 text-sm font-medium text-gray-900">
            New Password:
          </label>
          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'} // Toggle between 'text' and 'password'
              id="new-password-input"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-lg rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-3 mb-4"
              placeholder="Enter your new password"
              required
              value={newPassword}
              onChange={handleNewPasswordChange}
            />
            {/* Toggle visibility icon */}
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute right-3 top-1/2 transform -translate-y-1/2"
              aria-label="Toggle password visibility"
            >
              {showPassword ? <VisibilityOff className="text-gray-600" /> : <Visibility className="text-gray-600" />}
            </button>
          </div>
        </form>

        {/* Submit Button */}
        <button
          onClick={handleSubmit}
          className="w-full shadow-xl py-3 px-4 text-sm tracking-wide rounded-lg text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:outline-none focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-800 transition duration-300"
          disabled={loading}
        >
          {loading ? 'Changing Password...' : 'Change Password'}
        </button>
      </div>

      {/* ToastContainer to display toast notifications */}
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default ChangePasswordManage;
